<template>
  <v-app id="app">
    <div class="header-container">
      <div class="top-header-container">
        <router-link to="/home" style="text-decoration: none; color: inherit">
          <div class="header-image-container">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/jido-button.appspot.com/o/%E1%84%8B%E1%85%A7%E1%84%92%E1%85%A2%E1%86%BC%E1%84%87%E1%85%A5%E1%84%90%E1%85%B3%E1%86%AB.png?alt=media&token=a886c551-446a-440a-88db-31f496c39312"
              class="header-image"
            />
          </div>
        </router-link>
        <div class="right-menu">
          <a href="https://publebuble.com/play2">
            <button class="tint">바로 시작하기</button>
          </a>
        </div>
      </div>

      <div class="search-container">
        <b-nav
          v-if="searchResultList.length <= 0"
          class="s-core-dream-black margin-bottom-53"
        >
          <router-link to="/home">홈</router-link>
          <router-link to="/store">스토어</router-link>
          <!-- <router-link to="/magazine">매거진</router-link> -->
          <router-link to="/locations">지역별</router-link>
        </b-nav>

        <v-text-field
          placeholder="지역 또는 상품명을 입력해주세요"
          solo
          filled
          v-model="searchQuery"
          @keyup.enter="searchTest(searchQuery)"
        >
          <v-icon slot="append" color="red" @click="searchTest(searchQuery)">
            mdi-magnify
          </v-icon>
        </v-text-field>
        <SearchResultList
          v-bind:searchResultList="searchResultList"
          @emptySearchResultList="emptySearchResultList"
        />
      </div>
    </div>

    <div class="main-content">
      <router-view v-if="searchResultList.length <= 0"></router-view>
    </div>

    <footer>
      <img
        src="https://firebasestorage.googleapis.com/v0/b/jido-button.appspot.com/o/%E1%84%8B%E1%85%A7%E1%84%92%E1%85%A2%E1%86%BC%E1%84%87%E1%85%A5%E1%84%90%E1%85%B3%E1%86%AB.png?alt=media&token=a886c551-446a-440a-88db-31f496c39312"
        class="header-image"
        style="margin-bottom: 25px"
      />
      <p class="my-line-height">
        <span><span class="bold">|</span> 이용약관</span
        ><span class="indent"
          ><span class="bold">|</span> 개인정보처리방침</span
        >
      </p>
      <p class="my-line-height">
        <span class="bold">|</span> 상호명 : 슛버튼
        <span class="indent"><span class="bold">|</span> 대표 : 이재환</span
        ><span class="indent"
          ><span class="bold">|</span> 사업자등록번호 : 208-09-50733</span
        >
      </p>
      <p class="my-line-height">
        <span class="bold">|</span> 이메일 : traveltip15@naver.com
        <span class="indent"
          ><span class="bold">|</span> 전화번호 : 070-4218-7078</span
        >
      </p>
      <p class="my-line-height">
        <span class="bold">|</span> 주소 : 인천광역시 연수구 컨벤시아대로 204
        인천스타트업파크 205호
      </p>
      <div class="white-container">
        <p>
          ※ 여행버튼은 통신판매중개자로서 통신판매의 당사자가 아니며, 상품의
          예약, 이용 및 환불 등과 관련한 의무와 책임은 각 판매자에게 있습니다.
        </p>
      </div>
    </footer>
  </v-app>
</template>

<script>
import Vue from "vue";
import VueHorizontalList from "@/vue-horizontal-list.vue";

import ImageThree from "./image-three";

import Tabs from "./tabs";

import SearchResultList from "./search-result";

import VueHead from "vue-head";
import firebase from "firebase";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import MyHorizontalScroll from "./horizontal-scroll.vue";

import VueCarousel from "vue-carousel";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";

Vue.use(VueMaterial);
Vue.use(VueHead);
Vue.use(VueCarousel);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

export default Vue.extend({
  name: "Index",
  components: {
    VueHorizontalList,
    Tabs,
    MyHorizontalScroll,
    SearchResultList,
  },
  mounted() {
    if (this.$router.history._startLocation === "/") {
      this.$router.replace("/home");
    }
  },
  data() {
    return {
      searchQuery: "",
      searchResultList: [],
    };
  },
  methods: {
    searchTest(q) {
      this.emptySearchResultList();
      firebase
        .firestore()
        .collection("posts1")
        .orderBy("contents", "asc")
        .startAt(`${q}`)
        .endAt(`${q}\uf8ff`)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(doc.data());
            this.searchResultList.push(doc.data());
          });
          console.log(this.searchResultList);
        });
    },
    emptySearchResultList() {
      this.searchResultList = [];
    },
  },
  head: {
    title: {
      inner: "여행버튼",
      separator: "|",
      complement: "세상의 모든 여행을 여행버튼에서",
    },
    meta: [
      { name: "description", content: "description hoge" },
      {
        name: "viewport",
        content: "width=device-width,initial-scale=1.0,user-scalable=no",
      },
      { charset: "utf-8" },
      { property: "og:type", content: "website" },
    ],
  },
});
</script>

<style>
@font-face {
  font-family: "yg-jalnan";
  src: url("https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_four@1.2/JalnanOTF00.woff")
    format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "S-CoreDream-9Black";
  src: url("https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-9Black.woff")
    format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "S-CoreDream-4Regular";
  src: url("https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-4Regular.woff")
    format("woff");
  font-weight: normal;
  font-style: normal;
}

@media (min-width: 1080px) {
  #app {
    background: #f7f7f7;
    overflow: hidden;
  }

  .header-container {
    width: 100%;
    padding-left: 25%;
    padding-right: 24%;
    height: 378px;
    background: white;
  }

  .main-content {
    width: 50%;
    margin-left: 25%;
    margin-right: 24%;
  }

  .search-container {
    margin-left: 15%;
    width: 35vw;
  }

  ul.nav {
    margin-left: 15%;
    width: 65%;
  }
}

.header-image-container {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 25px;
}

.header-image {
  width: 120px;
  height: 28px;
}

.top-header-container {
  display: flex;
  justify-content: space-between;
}

.right-menu {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  margin-top: 18px;
}

.right-menu button {
  color: #888888;
}

.margin-left-36 {
  margin-left: 36px;
}

.right-menu .tint {
  background-color: #f9730c;
  border-radius: 25px;
  width: 178px;
  height: 46px;
  color: white;
}

@media screen and (max-width: 866px) {
  /* <여행버튼 매거진> 모바일 버전 대응 전까지 임시로 감추기 */
  .tint {
    display: none;
  }
}

.right-menu:nth-child(1) {
  width: 250px;
}

.top-header {
  text-align: center;
  padding-top: 25px; /* 브라우저 검색 창에 가려지는 거 work-around */
  padding-bottom: 25px;
  color: black;
  text-decoration: none !important;
}

.search-container {
  margin-top: 69px;
  margin-bottom: 40px;
}

ul.nav {
  display: flex;
  justify-content: space-around;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0 0 1px;
}

.yg-jalnan {
  font-family: "yg-jalnan";
}

.s-core-dream-black {
  font-family: "S-CoreDream-9Black", Helvetica, Arial;
}

.s-core-dream-regular {
  font-family: "S-CoreDream-4Regular", Helvetica, Arial;
}

.font-size-24 {
  font-size: 24px;
}

.margin-bottom-53 {
  margin-bottom: 53px;
}

p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  color: #333;
  word-break: break-word;
}

.my-line-height {
  font-size: 12px;
  line-height: 0.5;
}
</style>

<style scoped>
@media screen and (max-width: 420px) {
  #app {
    padding-left: 20px;
    padding-right: 20px;
  }
}

#app > div {
  margin: 14px 0;
}

.nav a {
  color: black !important;
  height: 22px;
  font-size: 24px;
}

.nav > a:hover {
  text-decoration: none;
}

.nav > .router-link-active {
  color: #f9730c !important;
  height: 0px;
}

.nav > .router-link-active:nth-child(1)::after {
  /* nav 첫 번째 메뉴인 "홈"은 한 글자라서 workaround... */
  content: "";
  display: block;
  width: 15px;
  border-bottom: 3px solid #f9730c;
  margin-left: -1px;
}

.nav > .router-link-active::after {
  content: "";
  display: block;
  width: 25px;
  border-bottom: 3px solid #f9730c;
  margin: 10px auto;
}

.router-link-active {
  font-weight: bold;
}

.nav {
  padding-bottom: 30px;
}

footer {
  background-color: rgba(232, 232, 232, 0.3);
  padding: 15px;
  width: 100%;
}

footer h1 {
  color: rgba(46, 49, 49, 0.6);
  margin-bottom: 10px;
}

footer p {
  font-size: 11px;
  letter-spacing: 0.05px;
  color: grey;
}

footer span {
  font-size: 11px;
  letter-spacing: 0.05px;

  color: grey;
}

.white-container {
  background-color: white;
}

.indent {
  margin-left: 16px;
}

.bold {
  font-weight: 700;
  color: rgba(46, 49, 49, 0.6);
}
</style>
